<template>
    <main>
        <Navbar />
        <div class="main">
            <div class="container">
                <form @submit.prevent="addClient">
                    <div class="form-group">
                        <label class="text-white" for="nome">Nome</label>
                        <input type="text" class="form-control" id="nome" v-model="nome" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="site">Site</label>
                        <input type="text" class="form-control" id="site" v-model="site" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="app_nome">Aplicativo</label>
                        <input type="text" class="form-control" id="app_nome" v-model="app_nome" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="api">API-SRV</label>
                        <input type="text" class="form-control" id="api" v-model="api" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="telefone">Telefone</label>
                        <input type="number" class="form-control" id="telefone" v-model="telefone" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="mensalidade">Mensalidade</label>
                        <input type="text" class="form-control" id="mensalidade" v-model="mensalidade" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="data-de-inicio">Data de início</label>
                        <input type="date" class="form-control" id="data-de-inicio" v-model="data_de_inicio" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="data-da-cobranca">Data da cobrança</label>
                        <input type="date" class="form-control" id="data-da-cobranca" v-model="data_da_cobranca" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-2 text-white">Esportes</div>
                        <div class="col-sm-10" :class="{'mt-3': platform == 'mobile'}">
                            <div class="form-check" :class="{'form-check-inline': platform == 'desktop'}" v-for="(esporte, key) in esportes" :key="key">
                                <input class="form-check-input" type="checkbox" :id="`gridCheck-${key}`" :value="esporte" :checked="checkListSelected(esporte)" @change="selectSport(esporte)">
                                <label class="form-check-label text-white" :for="`gridCheck-${key}`">{{esporte}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col">
                            <button type="submit" class="btn btn-block btn-success" :disabled="block">
                                <i class="fas fa-save mr-2"></i>Salvar
                            </button>
                        </div>
                        <div class="col">
                            <a class="btn btn-block btn-danger" @click="cancel" :class="{'disabled': block}">
                                <i class="fas fa-ban mr-2"></i>Cancelar
                            </a>
                        </div>
                    </div>
                </form>
            </div>
          <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
        </div>
    </main>
</template>

<script>
import {api} from '../api'
import Navbar from './Navbar'
import Swal from 'sweetalert2'
import moment from 'moment-timezone'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

const today = moment().tz('America/Recife').format('YYYY-MM-DD');
const next_month = moment().tz('America/Recife').add(1, 'months').format('YYYY-MM-DD');

export default {
    data() {
        return {
            api: '',
            nome: '',
            site: '',
            app_nome: '',
            block: true,
            esportes: [
                'Futebol',
                'Basquete',
                'Lutas',
                'Hóquei',
                'Voleibol',
                'Tênis',
                'E-Sports'
            ],
            loading: false,
            telefone: '',
            mensalidade: '',
            esportesList: ['Futebol'],
            data_de_inicio: today,
            data_da_cobranca: next_month,
            platform: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
            network_erros: {
				0: {
					message: 'Não há conexão com a internet!'
                },
                401: {
                    message: 'Você não tem autorização para realizar essa operação!'
                },
				404: {
					message: 'Página solicitada não foi encontrada!'
				},
				500: {
					message: 'O servidor está passando por problemas técnicos!'
				},
				408: {
					message: 'Por favor, verifique sua conexão de rede e tente novamente!'
				}					
			}
        }
    },
    components: {
        Navbar,
        Loading
    },
    methods: {
        cancel() {
            this.nome = '';
            this.site = '';
            this.app_nome = '';
            this.telefone = '';
            this.mensalidade = '';
            this.data_de_inicio = today;
            this.data_da_cobranca = next_month;
            this.esportesList = ['Futebol'];
        },
        addClient() {

            const self = this;

            if (self.trim(self.nome) == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o nome do cliente!',
                    'warning'
                )
            } else if (self.trim(self.site) == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o site do cliente!',
                    'warning'
                )
            } else if (self.trim(self.api) == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe a API do cliente!',
                    'warning'
                )
            } else if (self.trim(self.telefone) == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o número de telefone do cliente!',
                    'warning'
                )
            } else if (self.trim(self.mensalidade) == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o valor da mensalidade!',
                    'warning'
                )
            }
            else
            {
                Swal.fire({
                    title: 'Novo cliente',
                    html: `Você deseja mesmo registrar <b>${self.nome}</b> como seu novo cliente?`,
                    showCancelButton: true,
                    confirmButtonColor: '#28a745',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Sim'
                }).then((result) => {

                    if (result.value) {

                        self.loading = true;

                        api.post('add-client', {
                            telefone: self.telefone,
                            api: self.trim(self.api),
                            nome: self.trim(self.nome),
                            site: self.trim(self.site),
                            app_nome: self.trim(self.app_nome),
                            esportes: self.esportesList,
                            data_de_inicio: self.data_de_inicio,
                            data_da_cobranca: self.data_da_cobranca,
                            mensalidade: self.trim(self.mensalidade)
                        }).then((response) => {
                            switch(response.data.result) {
                                case 'success':

                                    self.cancel();

                                    Swal.fire(
                                        'Novo cliente \n cadastrado com sucesso!',
                                        `
                                            <label class="d-block text-left mb-0">ID</label>
                                            <input id="swal2-client-id" class="swal2-input text-center" value="${response.data.client_id}" type="text" onclick="window.copyClipboard('swal2-client-id');" readonly autocomplete="off" spellcheck="false" />
                                            
                                            <label class="d-block text-left mb-0">Link do cadastro</label>
                                            <input id="swal2-client-pin" class="swal2-input text-center" value="https://payment.bnow.bet/pay?pin=${response.data.pin}&edit=true&action=edit" type="text" onclick="window.copyClipboard('swal2-client-pin');" readonly autocomplete="off" spellcheck="false" />
                                        `,
                                        'success'
                                    );
                                break;
                                default:
                                    Swal.fire(
                                        'Atenção',
                                        response.data.message,
                                        'warning'
                                    );
                                break;
                            }
                        }).catch((error) => {
                            try {
                                Swal.fire(
                                    'Falha',
                                    self.network_erros[error.status]['message'],
                                    'warning'
                                );
                            } catch(e) {
                                Swal.fire(
                                    'Falha',
                                    self.network_erros[408]['message'],
                                    'warning'
                                );
                            }
                        }).finally(() => {
                            self.loading = false;
                        });
                    }
                });
            }
        },
        selectSport(sport) {
            if (this.esportesList.includes(sport)) {

                let index = this.esportesList.indexOf(sport);

                if (index !== -1) {
                    this.esportesList.splice(index, 1);
                }
            }
            else
            {
                this.esportesList.push(sport);
            }
        },
        checkListSelected(sport) {
            if (this.esportesList.includes(sport)) {
                return true;
            } else {
                return false;
            }
        },
        trim(value) {
            return value.toString().trim();
        }
    },
    watch: {
        nome(value) {
            this.nome = value.replace(/[^a-zà-ú0-9\s]+/gi,'');
            this.app_nome = value.toString().toLowerCase().replace(/\s/g,'');
        },
        site(value) {
            this.site = value.replace(/[^a-z0-9.-]+/gi,'');
            this.api = this.site.replace('www','api');
        },
        app_nome(value) {
            this.app_nome = value.replace(/[^a-z0-9.-]+/gi,'');
        },
        api(value) {
            this.api = value.replace(/[^a-z0-9.-]+/gi,'');
        },
        mensalidade(value) {
            this.mensalidade = value.replace(/[^0-9]+/gi,'');
        },
        data_de_inicio(value) {
            this.data_da_cobranca = moment(value).tz('America/Recife').add(1, 'months').format('YYYY-MM-DD');
        }
    },
    beforeMount() {
        try {

            const {pipe} = JSON.parse(localStorage.getItem('auth'));

            this.block = pipe == 1 ? false : true;
        } catch(e) {
            this.block = false;
        }
    },
    mounted() {
        window.copyClipboard = (id) => {

            var copyText = document.getElementById(id);

            if (copyText) {
                navigator.clipboard.writeText(copyText.value).then(() => {
                    Swal.fire(
                        'Parabéns!',
                        'O <strong>ID</strong> foi copiado com sucesso!',
                        'success'
                    )
                }, () => {
                    Swal.fire(
                        'Erro!',
                        'Não foi possível copiar o <strong>ID</strong>!',
                        'error'
                    )
                }); 
            } 
        }
    }
}
</script>